<template>
  <div v-if="frame" class="hotdot-tag" :class="animClass" v-bind:style=[outerStyleObj] @click="onClick">
    <div class="hotdot" :style="bgStyles">
       <i v-if="meta.icon" class="material-icons" :style="fgStyles">{{meta.icon}}</i>
    </div>
  </div>
</template>
<script>

import { analytics } from './mixins/analytics/'

export default {
  name: "hotdot",
  mixins: [analytics],
  props: ["hotdot", "meta", "frame", "isLastFrame", "dimensions"],
  created() {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName("viewer-video")[0];
    });
    console.log("hotdot created", this.hotdot);
    this.initTag();
  },
  watch: {
    isLastFrame(isLast) {
      console.log(
        "hotDotTag isLastFrame %s. current frame %v",
        isLast,
        this.frame
      );
      if (isLast && this.onLastFrame.action !== "none") {
        this.$emit("videoaction", this.onLastFrame);
      }
    },
    hotdot: "initTag"
  },
  data() {
    return {
      videoElement: null
    };
  },
  computed: {
    outerStyleObj: function() {
      var w = this.frame.pw * this.dimensions.w;
      var h = this.frame.ph * this.dimensions.h;
      var so = {
        width: w + "px",
        height: h + "px",
        "margin-top": -h / 2 + "px",
        "margin-left": -w / 2 + "px",
        "font-size": `${Math.max(24, h * 0.85)}px`
      };
      if (this.animation && this.animation.animation && !this.animation.animation.includes('pulse')) {
        var a = this.animation
        let av = ''
        if (a.value) {
          av = `${a.animation} ${a.value || 2000}ms ${a.mode}`
        } else {
          av = `${a.animation} ${a.duration || 2}s infinite`
        }

        so['animation'] = av
      }
      return so;
    },
    animClass: function() {
      return (this.animation && this.animation.animation && this.animation.animation.includes('pulse')) ? this.animation.animation : ''
    },
    bgStyles: function() {
      if (this.bgColor) {
        return `background-color: ${this.bgColor}`
      }
      return null
    },
    fgStyles: function() {
      if (this.fgColor) {
        return `color: ${this.fgColor}`
      }
      return null
    }
  },
  methods: {
    initTag() {
      console.log("hotdot.inited");
      var meta = this.hotdot.meta
      this.onLastFrame = meta.onLastFrame || {};
      this.behaviour = meta.behaviour || {};
      this.animation = this.hotdot.meta.animation;
      this.fgColor = ((meta.colorScheme || {}).colors || [])[1]
      this.bgColor = ((meta.colorScheme || {}).colors || [])[0]
    },
    onClick() {
      console.log("onHotDot clicked", this.hotdot);
      this.$emit("action", this.hotdot.meta.behaviour);
      this.trackTag("HotDot")
      /*
      this.$emit('open', {
        target: 'iframe',
        value: this.hotdot.meta.URL
      })
      */
    }
  }
};
</script>
